export enum LoaderSize {
  Small = 'small',
  Large = 'large',
}
